// extracted by mini-css-extract-plugin
export default {"simplecard":"simple_card_simplecard__apny+","simplecard__title":"simple_card_simplecard__title__ZkIon"};